export default "__VITE_ASSET__B0t2$71$__"